import type { IconName } from "@/components/ui/Icon.vue";

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  admin?: boolean;
  /** for the organisation's admins and a workspace's admins (2026-10-27) */
  teamAdmin?: boolean;
  match?: RegExp;
}
/** Whether to list `n` for this person; the server still decides what they may open. */
export const listed = (n: NavItem, admin: boolean, teamAdmin: boolean) => (!n.admin || admin) && (!n.teamAdmin || admin || teamAdmin);
export const navigation: { label: string; items: NavItem[] }[] = [
  { label: "Work", items: [
    { to: "/", label: "Mission Control", icon: "grid" },
    { to: "/ask", label: "Ask Majlis", icon: "message" },
    { to: "/tickets", label: "Tickets", icon: "branch", match: /^\/(tickets|runs)(\/|$)/ },
    { to: "/guide", label: "Guide", icon: "book" },   // how to do things, step by step (H-167)
  ] },
  { label: "Build", items: [
    { to: "/connectors", label: "Connectors", icon: "link" },   // workspaces bring their own connections (H-153)
    { to: "/agents", label: "Agents", icon: "sparkle" },
    { to: "/workspaces", label: "Workspaces", icon: "user" },
    // the leaders an organisation admin names, each to create their team's workspace (onboarding, 2026-10-26); in the
    // menu since 2026-11-01 (Amine: "add for me a space ... where I can invite our leaders with their email")
    { to: "/leaders", label: "Leaders", icon: "target", admin: true },
    { to: "/projects", label: "Jira projects", icon: "layers" },
    { to: "/skills", label: "Skills", icon: "list" },
    { to: "/notes", label: "Notes", icon: "file" },
    { to: "/onboarding", label: "Connect a project", icon: "plus", admin: true },
  ] },
  { label: "Govern", items: [
    { to: "/decisions", label: "Decisions", icon: "check" },
    { to: "/budgets", label: "Budgets", icon: "dollar", admin: true },
    { to: "/biographie-channels", label: "Biographie channels", icon: "message", admin: true },
    { to: "/bindings", label: "Bindings", icon: "lock" },
    { to: "/readiness", label: "Repo readiness", icon: "shield" },
    { to: "/feedback/inbox", label: "Feedback inbox", icon: "message", admin: true },   // people's reports about Majlis (2026-10-27)
    // where Majlis failed people, found without anyone reporting it (feedback-loop plan, 2026-11-01)
    { to: "/quality", label: "Missed answers", icon: "shield", teamAdmin: true },
    { to: "/feedback/shared", label: "Shared feedback", icon: "message", teamAdmin: true },   // excerpts for a workspace's admins
  ] },
  { label: "More", items: [
    { to: "/map", label: "Code map", icon: "map" },
    { to: "/labs", label: "Code map labs", icon: "flask", admin: true, match: /^\/labs(\/|$)/ },   // three prototypes (2026-10-21)
    { to: "/brief", label: "Brief", icon: "brief" },
    { to: "/architecture", label: "Architecture", icon: "layers" },
    { to: "/compare", label: "Compare", icon: "compare" },
    { to: "/flows", label: "All flows", icon: "play", match: /^\/(flows|run)(\/|$)/ },
    { to: "/configs", label: "Configurations", icon: "settings" },
    { to: "/schedules", label: "Workflow schedules", icon: "calendar" },   // agents' own schedules are on each agent's page
    { to: "/mappings", label: "Mappings", icon: "link", admin: true },
    { to: "/lineage", label: "Everything connected", icon: "branch" },
    { to: "/feedback", label: "My feedback", icon: "message", match: /^\/feedback(\/(?!inbox|shared)|$)/ },
  ] },
];
